exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-bundle-body p[data-v-3a20e836]{margin:0}.card-bundle-body[data-v-3a20e836]{padding:10px;font-family:Montserrat,Helvetica Neue,sans-serif;color:#24323b}.price[data-v-3a20e836]{font-size:18px;padding-top:18px;font-weight:400;color:#384853}.card-bundle[data-v-3a20e836]{overflow:hidden;margin:10px;background-color:#fff}.btn-purchase[data-v-3a20e836]:hover{background-color:#e6bc00}.btn-purchase[data-v-3a20e836]{padding-top:8px;width:100%;margin-top:10px;border-radius:0;background-color:#ffd400;color:#333;height:38px;font-family:Montserrat,Helvetica Neue,sans-serif}.card-title[data-v-3a20e836]{font-size:15px;font-weight:300}.div-img[data-v-3a20e836]{min-height:373px}.description-text[data-v-3a20e836]{min-height:75px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a20e836","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/store/components/CardBundle.vue
// module id = rX9M
// module chunks = 102